/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CommonTipsDialog.vue?vue&type=template&id=6da10dad&scoped=true"
import script from "./CommonTipsDialog.vue?vue&type=script&lang=js"
export * from "./CommonTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./CommonTipsDialog.vue?vue&type=style&index=0&id=6da10dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da10dad",
  null
  
)

export default component.exports